// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.
/* eslint-disable */

const Filter = ((($) => {
  let url;
  let inputs;
  let show;
  let hideit;
  let items;
  let newArray;
  let filtering_array;
  let building_title;
  let i;
  // let input_bedrooms;
  // let input_surface;
  function init() {
    url = 'https://backoffice.drawbotics.com/api/public/v2/listings/33970';
    ajaxGetJson();
    submitFilter();
    $('.filter-cancel').on('click', (e) => {
      e.preventDefault();
      ajaxGetJson();
    });
    $('.show-more').on('click', (e) => {
      e.preventDefault();
      $('.show-more').css('display', 'none');
      $('#filter-results').find('.hidden').removeClass('hidden');
    });
  }

  function ajaxGetJson() {
    $.ajax({
      type: 'GET',
      url: url,
      data: '',
      dataType: 'json',
      success: function(data) {
        show = '';
        hideit = '';
        //console.log(data.resource.units);
        $('.items-counter').text(data.resource.units.length);
        $.each( data.resource.units, (key, item) => {
          if(key > 10) {
            hideit = 'hidden';
          }
          if(item.reference.slice(0,2) === 'A1' || item.reference.slice(0,2) === 'A2' || item.reference.slice(0,2) === 'A3' || item.reference.slice(0,3) === 'RDC' || item.reference.slice(0,3) === 'RDJ'){
            building_title = 'Gemini';
          }
          else if(item.reference.slice(0,2) === 'B7') {
            building_title = 'Sagitta';
          }
          else if(item.reference.slice(0,2) === 'B6') {
            building_title = 'Vela';
          }
          else if(item.reference.slice(0,2) === 'B8') {
            building_title = 'Andromeda';
          }
          else{
            building_title = 'Cepheus'
          }
          show += '<div data-id="'+key+'" class="appartment-item '+hideit+'">' +
              '<div class="appartment-item_num">' +
              '<span class="s-title">'+item.reference+'</span>' +
              '</div>' +
              '<div class="appartment-item_values">' +
              '<b>'+building_title+'</b>' +
              '<span>'+item.surface+'m2</span>' +
              '<span>' + item.rooms + ' chambres</span>' +
              '</div>' +
              '<div class="appartment-item_icons">' +
              '<a class="icon icon-revo scroll-to" href="#revo-box"></a>' +
              '<a class="icon icon-phone contact-btn" href="#"></a>' +
              '</div><div class="appartment-item_btn">' +
              '<a href="'+item.mainImageUrl+'" data-fancybox target="_blank" class="btn btn-cta btn-rounded inversed">TÉLÉCHARGER LES PLANS</a>' +
              '</div>' +
              '</div>';
        });
        $('#filter-results').html(show);
      }
    });
  }

  function submitFilter() {
    $('#filter').on('submit', function(e) {
      e.preventDefault();
      inputs = $(this).serializeArray();
      $.ajax({
        type: 'GET',
        url: url,
        data: '',
        dataType: 'json',
        success: function(data) {
          /*
          * option(value="B7") Sagitta
              option(value="B6") Vella
              option(value="A1/RDC/RDJ") Gemini
              option(value="B8") Andromeda
              option(value="C") Maisons
          * */
          show = '';
          hideit = '';
          items = data.resource.units;
          filtering_array = [];
          filtering_array.push(inputs[0].value);
          filtering_array.push(inputs[1].value);
          if(inputs[2].value) {
            filtering_array.push(inputs[2].value.split(';')[0]);
            filtering_array.push(inputs[2].value.split(';')[1]);
          }
          newArray = items;
          for(i = 0; i < filtering_array.length; i++) {
            if (filtering_array[i].length) {
              if(i === 0) {
                if(filtering_array[i] === 'A1') {
                  newArray = newArray.filter((el) => {
                    return el.reference.slice(0,3) === 'RDJ' || el.reference.slice(0,3) === 'RDC' || el.reference.slice(0,2) === 'A1' || el.reference.slice(0,2) === 'A2' || el.reference.slice(0,2) === 'A3';
                  });
                }
                else if (filtering_array[i] === 'C') {
                  newArray = newArray.filter((el) => {
                    return el.reference.slice(0,1) === filtering_array[i];
                  });
                }
                else {
                  newArray = newArray.filter((el) => {
                    return el.reference.slice(0,2) === filtering_array[i];
                  });
                }
              }
              if(i === 1) {
                newArray = newArray.filter((el) => {
                  return el.bedrooms === filtering_array[i]-1;
                });
              }
              if(i === 2) {
                newArray = newArray.filter((el) => {
                  return el.surface >= filtering_array[i];
                });
              }
              if(i === 3) {
                newArray = newArray.filter((el) => {
                  return el.surface <= filtering_array[i];
                });
              }
            }
          }
          $('.items-counter').text(newArray.length);
          if(newArray.length < 10) {
            $('.show-more').hide('fast');
          }
          else {
            $('.show-more').show('fast');
          }
          $.each( newArray, (key, item) => {
            if(key > 10) {
              hideit = 'hidden';
            }
            if(item.reference.slice(0,2) === 'A1' || item.reference.slice(0,2) === 'A2' || item.reference.slice(0,2) === 'A3' || item.reference.slice(0,3) === 'RDC' || item.reference.slice(0,3) === 'RDJ'){
              building_title = 'Gemini';
            }
            else if(item.reference.slice(0,2) === 'B7') {
              building_title = 'Sagitta';
            }
            else if(item.reference.slice(0,2) === 'B6') {
              building_title = 'Vela';
            }
            else if(item.reference.slice(0,2) === 'B8') {
              building_title = 'Andromeda';
            }
            else{
              building_title = 'Cepheus'
            }
            show += '<div data-id="'+key+'" class="appartment-item '+hideit+'">' +
              '<div class="appartment-item_num">' +
              '<span class="s-title">'+item.reference+'</span>' +
              '</div>' +
              '<div class="appartment-item_values">' +
              '<b>'+building_title+'</b>' +
              '<span>'+item.surface+'m2</span>' +
              '<span>' + item.rooms + ' chambres</span>' +
              '</div>' +
              '<div class="appartment-item_icons">' +
              '<a class="icon icon-revo scroll-to" href="#revo-box"></a>' +
              '<a class="icon icon-phone contact-btn" href="#"></a>' +
              '</div><div class="appartment-item_btn">' +
              '<a href="'+item.mainImageUrl+'" data-fancybox class="btn btn-rounded inversed btn-cta">TÉLÉCHARGER LES PLANS</a>' +
              '</div>' +
              '</div>';
          });
          $('#filter-results').html(show);

        }
      });
    });
  }

  return {
    init,
  };
}))(jQuery);

// don't forget to export
export default Filter;



// WEBPACK FOOTER //
// ./src/static/js/modules/filter.js